export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export const API_URL = process.env.REACT_APP_API_URL;
